import api from '@services/api';

import { CompletePerson } from '../models/person';

/**
 * <p>
 * API endpoints that cover all person related CRUD calls
 */
export const personApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    PaymentWithoutSharing: builder.query<Array<CompletePerson>, string>({
      query: (period) => ({
        url: encodeURI(`/school/person/findPaymentWithNoSharing?periodDate=${period}`),
        method: 'GET',
      }),
      providesTags: ['Person'],
    }),
  }),
});

export const { usePaymentWithoutSharingQuery } = personApi;
